import React from 'react';

export default class ShortagePercent extends React.Component {
    static round(number, precision) {
        let factor = Math.pow(10, precision);
        let tempNumber = number * factor;
        let roundedTempNumber = Math.round(tempNumber);
        return roundedTempNumber / factor;
    }

    render() {
        let result = this.constructor.round(this.props.row.shortageTonnes, 4);
        return <span>{!isNaN(result) && result.toLocaleString('en-US', {
            style: 'decimal',
        }).replace(/,/g, " ")}</span>;
    }
}


// WEBPACK FOOTER //
// ./src/components/cargo/tableComponents/ShortageTonnes.js